import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { SubFormComponent } from '../../sub-form/sub-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multi-choice-template',
  template: `
<div class="hazard-description radio-buttons hazard-details" [formGroup]="group" *ngIf="field.style.visibility">
  <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
  <mat-radio-group class="example-radio-group" [ngClass]="{'pointer-events' : !field.style.editability}" *ngFor="let item of field.data | keys;let i = index">
    <mat-radio-button class="example-radio-button" (change)="onChange(item,i)" [checked]="selected() === item.key" [value]="item.key">
      {{item.value}}
    </mat-radio-button>
  </mat-radio-group>
  <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  <button *ngIf="isSubFormFound()" class="view-details" (click)="viewDetails()">View/edit details <img src="assets/rff-images/hazard-redirect.svg"></button>
</div>
`,
})
export class MultiChoiceTemplateComponent implements OnInit {

  field: FieldConfig;
  group: FormGroup;
  selectValues;

  constructor(
    private _validationService: ValidationService,
    private modalService: NgbModal,
  ) { }

  onChange(selectedItem, index) {
    let selectedOption = {};
    selectedOption[selectedItem.key] = selectedItem.value;
    this.selectValues = selectedOption;

    const templateId = (this.field.data[index] && this.field.data[index]['formTemplateId']) ? this.field.data[index]['formTemplateId'] : undefined;

    if (templateId) {
      this.subFormFound(templateId, index);
    } else {
      this.field.value = {
        label: this.field.name,
        selectedIndex: index
      }
    }
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }

  isSubFormFound() {
    if (this.field.value && this.field.value.data) {
      return true;
    }
    return false;
  }

  selected() {
    if (this.selectValues) {
      const items = Object.keys(this.selectValues);
      return items[0];
    }
  }
  subFormFound(templateId, index) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-large',
    };
    const modalRef = this.modalService.open(
      SubFormComponent,
      modalOptions
    );

    modalRef.componentInstance.formId = templateId;

    if (this.field.value && this.field.value['data']) {
      modalRef.componentInstance.data = this.field.value['data'];
    }

    modalRef.componentInstance.isEditable = this.field.style.editability;

    modalRef.result.then((data) => {

      this.field.value = {
        label: this.field.name,
        selectedIndex: index,
        data: data.data,
        template: data.template
      }
      this.group.value[this.field.id] = this.field.value;
      const datas = this.group.value;
      this._validationService.applyValidation(this.field, datas, [ValidationType.isRequired, ValidationType.onChange]);
    });
  }

  viewDetails() {

    const templateId = this.field.data[this.field.value.selectedIndex]['formTemplateId'];
    if (templateId) {
      this.subFormFound(templateId, this.field.value.selectedIndex);
    }

  }


  ngOnInit() {
    if (this.field.value) {
      this.selectValues = this.field.data[this.field.value.selectedIndex]
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/multi-choice-template/multi-choice-template.component.ts